import { render, staticRenderFns } from "./FrequentlyComponent.vue?vue&type=template&id=10b772b7&scoped=true"
import script from "./FrequentlyComponent.vue?vue&type=script&lang=js"
export * from "./FrequentlyComponent.vue?vue&type=script&lang=js"
import style0 from "./FrequentlyComponent.vue?vue&type=style&index=0&id=10b772b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b772b7",
  null
  
)

export default component.exports